import styled from 'styled-components';

export const Wrapper = styled.div`
  font-size: 14px;
  background-color: ${({ color }) => color};
  padding: 0 10px;
  border-radius: 50px;
  color: ${props => props.theme.colors.white};
`;



// WEBPACK FOOTER //
// ./src/components/colored-label/styled-components.js